// Firebase provider — file-transfer / capability surface (S8).
//
// Internet file share is a Supabase-only capability. The firebase provider
// keeps its existing Beam behavior (P2P on LAN + the F11.4 Firestore
// store-and-forward fallback) and does NOT gain a cloud-share UX, so it
// advertises `internetFileShare: false`. The UI gates the affordance on that
// flag and never calls `uploadFile` here — the throw is a guardrail, not a
// code path.
export const capabilities = { internetFileShare: false };

/**
 * Guardrail: the firebase provider has no cloud-storage upload. The UI hides
 * the affordance when `capabilities.internetFileShare` is false, so this only
 * fires if something bypasses the capability check.
 *
 * @returns {Promise<never>}
 */
export async function uploadFile() {
  throw new Error('internetFileShare not supported on the firebase provider');
}

/**
 * No cloud indirection on firebase — the path is already the usable handle.
 *
 * @param {string} path
 * @returns {string}
 */
export function getFileUrl(path) {
  return path;
}

/**
 * No-op: nothing to clean up when there's no cloud object.
 *
 * @returns {Promise<void>}
 */
export async function deleteFile() {
  /* no-op */
}
